import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button } from 'reactstrap';

function InstallAppBanner() {
  const [showBanner, setShowBanner] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const isMobileDevice = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    setIsMobile(isMobileDevice);
    setShowBanner(true);
  }, []);

  if (!showBanner || !isMobile) return null;

  return (
    <>
      <div style={{
        color: '#000',
        padding: '10px',
        position: 'fixed',
        top: 0,
        width: '100%',
        zIndex: 9999,
        textAlign: 'center',
        boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
        justifyContent: 'space-between'
      }} className='d-flex align-items-center w-100 bg-primary'>
        <p className='m-0' style={{color: "#FFF"}}>📲 Instalar o Automapro Aviator</p>
        <button
          style={{
            backgroundColor: '#6f42c1',
            border: 'none',
            color: '#fff',
            padding: '6px 12px',
            marginLeft: '10px',
            borderRadius: '4px'
          }}
          onClick={() => setModalOpen(true)}
        >
          Instalar
        </button>
      </div>

      <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)}>
        <ModalHeader toggle={() => setModalOpen(false)}>Como instalar o app</ModalHeader>
        <ModalBody>
          <p><strong>Android (Google Chrome):</strong></p>
          <ol>
            <li style={{color: "#525f7f"}}>Toque nos três pontinhos no canto superior direito.</li>
            <li style={{color: "#525f7f"}}>Escolha <strong>“Adicionar à tela inicial”</strong>.</li>
            <li style={{color: "#525f7f"}}>Confirme e pronto!</li>
          </ol>

          <p><strong>iPhone (Safari):</strong></p>
          <ol>
            <li style={{color: "#525f7f"}}>Toque no botão de compartilhamento (ícone com seta para cima).</li>
            <li style={{color: "#525f7f"}}>Toque em <strong>“Adicionar à Tela de Início”</strong>.</li>
            <li style={{color: "#525f7f"}}>Confirme e pronto!</li>
          </ol>
        </ModalBody>
      </Modal>
    </>
  );
}

export default InstallAppBanner;
